<template>
  <b-modal
    id="modal-skip-item"
    v-model="localShowModal"
    :title="titleModal"
    no-close-on-backdrop
    scrollable
    centered
    size="md"
  >
    <FormulateForm
      ref="form"
      @submit="onConfirm"
    >
      <b-row>
        <b-col>
          <FormulateInput
            id="skip-item-input-nsu"
            :value="movementDate"
            :label="$t('Data')"
            type="label"
          />
        </b-col>
        <b-col>
          <FormulateInput
            id="skip-item-input-value"
            :value="paidAmount"
            :label="$t('Valor')"
            type="label"
            filter="currency"
          />
        </b-col>
        <b-col md="12">
          <FormulateInput
            id="skip-item-comments"
            v-model="localData.comments"
            :label="$t('Observação')"
            type="textarea"
            rows="3"
          />
        </b-col>
      </b-row>
    </FormulateForm>

    <template #modal-footer>
      <b-row class="w-100 d-flex justify-content-between align-items-center">
        <b-col class="d-flex justify-content-end">
          <e-button
            id="modal-skip-item-items-btn_cancel"
            class="mr-1"
            variant="outline-primary"
            :text="$t('Cancelar')"
            @click="hideModal"
          />

          <e-button
            id="modal-skip-item-items-btn_confirm"
            variant="primary"
            :text="$t('Confirmar')"
            :busy="saving"
            @click="onConfirm"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol } from 'bootstrap-vue'
import EButton from '@/views/components/EButton.vue'
import { mapActions } from 'vuex'

export default {
  components: { BModal, BRow, BCol, EButton },
  mixins: [],
  props: {
    conciliationId: {
      type: Number,
      require: true,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      saving: false,
      localShowModal: false,
      localData: {
        getnetData: {},
      },
    }
  },
  computed: {
    titleModal() {
      return `${this.$t('Ignorar transação')} / NSU: ${this.nsuAcquirer}`
    },
    nsuAcquirer() {
      return this.localData?.transactionId
    },
    movementDate() {
      return this.$options.filters.date(this.localData?.movementDate)
    },
    paidAmount() {
      return this.localData?.paidAmount
    },
  },
  watch: {
    data(val) {
      this.localData = val
    },
  },
  methods: {
    ...mapActions('pages/financial/reconciliation/santander/pix/maintain', ['skipItem']),
    showModal(data) {
      this.localShowModal = true
      this.localData = data
    },
    hideModal() {
      this.localShowModal = false
    },
    async onConfirm() {
      if (this.$refs.form.isValid) {
        try {
          this.saving = true
          await this.skipItem({
            conciliationId: this.conciliationId,
            itemId: this.localData.id,
            comments: this.localData.comments,
          })
          this.hideModal()
        } catch (error) {
          this.showError({ error })
        } finally {
          this.saving = false
        }
      } else {
        this.showInvalidDataMessage()
      }
    },
  },
}
</script>
